<template>
    <div class="carBox" @mouseup="handleMouseUp">
        <el-card ref="left_tree" class="box-card treeBox" style="height: calc(100vh - 152px);width: 300px;overflow-y: auto">
            <el-tree :data="projectDivisionData" node-key="value" :highlight-current="true" ref="my-tree" @node-click="clickPrjectDivision" default-expand-all :expand-on-click-node="false"></el-tree>
        </el-card>
        <div ref="resizeHandle" class="handle-resize" />
        <div ref="moveDiv" class="handle-resize-h" />
        <div class="newBox" style="width: calc(100% - 290px)">
        <div class="searchBox">

            <div class="searchGroup">
                <label>编号：</label>
                <el-input v-model="search_Obj.f_code" clearable @keyup.enter.native="doSearch" style="width: 130px"></el-input>
            </div>
            <div class="searchGroup">
                <label>简称：</label>
                <el-input v-model="search_Obj.f_alias" clearable @keyup.enter.native="doSearch" style="width: 130px"></el-input>
            </div>
            <!-- <div class="searchGroup">
                <label>灌浆类型：</label>
                <el-select v-model="search_Obj.f_grout_type" clearable placeholder="请选择" @keyup.enter.native="doSearch">
                    <el-option v-for="item in enuObj('grout_type')" :key="'grout_type'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </div> -->
            <el-button type="primary" size="medium" icon="el-icon-search" @click.native="doSearch">搜索</el-button>
        </div>
    <el-card ref="right_content" class="box-card">
        <div class="mainBody">
        <div class="btnBox">
            <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick"></Btns>
        </div>
            <div class="dataBox">
                                <div class="djBox" v-if="parents && parents.length>0" >
                                    <i class="el-icon-caret-right"></i>
                                    <el-breadcrumb separator-class="el-icon-arrow-right" style="display: inline-block;position: relative;top: 1px;margin-left: 4px">
                                        <el-breadcrumb-item v-for="p in parents.slice().reverse()" :key="'p'+p.id"><span class="pppp" @click="toChild1(p.id)">{{p.name}}</span></el-breadcrumb-item>
                                    </el-breadcrumb>
                                </div>
                                <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                                    <el-table-column prop="alias" label="所属工程" sortable="custom">
                                        <template slot-scope="scope">
                                            <span>{{ scope.row.pname }}</span><span v-if="grade>1">&nbsp;/&nbsp;</span><span>{{scope.row.alias}}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="grout_type" label="灌浆类型" width="120" v-if="grade !=4">
                                        <template slot="header">
                                            <el-dropdown trigger="click" size="medium " @command="handleCommand">
                                                <span class="el-dropdown-link" style="cursor: pointer;color: #409EFF;">
                                                    灌浆类型<i class="el-icon-arrow-down el-icon--right"></i>
                                                </span>
                                                <el-dropdown-menu slot="dropdown">
                                                    <el-dropdown-item command="">总体</el-dropdown-item>
                                                    <el-dropdown-item v-for="(item, idx) in enuObj('grout_type')" :key="'selgt'+idx" :command="item.key">
                                                        {{ item.title }}
                                                    </el-dropdown-item>
                                                </el-dropdown-menu>
                                            </el-dropdown>
                                        </template>
                                        <template v-if="grout_type">
                                            <span>{{ transEnu(grout_type, "grout_type") }}</span>
                                        </template>
                                        <template v-else>
                                            <span>总体</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="grout_type" label="灌浆类型" width="120" v-if="grade == 4">
                                        <template slot="header">
                                            <el-dropdown trigger="click" size="medium " @command="handleCommand">
                                                <span class="el-dropdown-link" style="cursor: pointer;color: #409EFF;">
                                                    灌浆类型<i class="el-icon-arrow-down el-icon--right"></i>
                                                </span>
                                                <el-dropdown-menu slot="dropdown">
                                                    <el-dropdown-item command="">全部</el-dropdown-item>
                                                    <el-dropdown-item v-for="(item, idx) in enuObj('grout_type')" :key="'selgt'+idx" :command="item.key">
                                                        {{ item.title }}
                                                    </el-dropdown-item>
                                                </el-dropdown-menu>
                                            </el-dropdown>
                                        </template>
                                        <template slot-scope="scope" v-if="grade == 4">
                                            <span>{{ transEnu(scope.row.grout_type, "grout_type") }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="plan_length" label="计划长度(m)" key="plan_length" sortable="custom" width="140" v-if="grout_type==null"></el-table-column>
                                    <el-table-column prop="plan_m2" label="计划平米(m²)" key="plan_volume" sortable="custom" width="140" v-if="grout_type==null"></el-table-column>
                                    <el-table-column prop="plan_length1" label="计划长度(m)" key="plan_length1" sortable="custom" width="140" v-if="grout_type==1"></el-table-column>
                                    <el-table-column prop="plan_m2" label="计划平米(m²)" key="plan_m2" sortable="custom" width="140" v-if="grout_type==1">
                                        <template>
                                            <span>0</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="plan_length2" label="计划长度(m)" key="plan_length2" sortable="custom" width="140" v-if="grout_type==2"></el-table-column>
                                    <el-table-column prop="plan_m2" label="计划平米(m²)" key="plan_m2" sortable="custom" width="140" v-if="grout_type==2">
                                        <template>
                                            <span>0</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="plan_length3" label="计划长度(m)" key="plan_length3" sortable="custom" width="140" v-if="grout_type==3"></el-table-column>
                                    <el-table-column prop="plan_m2" label="计划平米(m²)" key="plan_volume3" sortable="custom" width="140" v-if="grout_type==3"></el-table-column>
                                    <el-table-column label="操作" width="140" key="ccczzz" align="center" v-if="grade==4">
                                        <template slot-scope="scope">
                                            <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick"></LabBtns>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
            <div class="pageBox">
                                <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50]" :current-page="current" :page-size="pagesize" :total="total" @current-change="pageChange" @size-change="handleSizeChange"></el-pagination>
                            </div>
            <ProjectPlan
                                width="600px"
                                title="设置项目总计划"
                                :isshow="planshow"
                                @on-close="closePlanDialog">
                            </ProjectPlan>
        </div>
    </el-card>
</div>
<Edit
                    width="600px"
                    :id="model_id"
                    :title="edit_title"
                    :isshow="editshow"
                    @on-close="closeEditDialog"
                    @on-save-ok="saveOk">
                </Edit>
                <Import
                    width="600px"
                    title="导入工程结构"
                    :isshow="importshow"
                    @on-close="closeImportDialog"
                    @on-imp-ok="impOk">
                </Import>
    </div>
</template>

<script>
import Btns from "@/components/common/btns"
import LabBtns from "@/components/common/labbtns"
import Edit from "./edit"
import Import from "./import"
import ProjectPlan from "./projectplan"
import listutil from "@/libs/listutil"
import { getListData } from '@/api/common'
import { getProjectDivisionTreeData } from '@/api/org'

export default {
    name: 'planList',
    mixins: [listutil],
    components: {Edit, Import, ProjectPlan, Btns, LabBtns},
    data() {
        return {
            m_name: '工程划分',
            menu_id: 4100,
            list_url: "/api/admin/projectdivision/list",
            search_Obj: {
                f_code: '',
                f_name: '',
                f_alias: '',
                f_grout_type: '',
                f_pid: '',
                pid: '',
            },
            enu_name: ['grout_type'],
            parents: [],
            projectDivisionData: [],
            grade: 1,
            pid: 0,
            sortData: {
                prop: 'order_index',
                order: 'ascending'
            },
            importshow: false,
            planshow: false,
            grout_type: '',
        };
    },
    mounted(){
        this.dragControllerDiv(this.$refs.left_tree.$el, this.$refs.resizeHandle, this.$refs.moveDiv)
    },
    methods: {
        setPlan(index, row) {
            this.edit_title = "设置计划量"
            this.model_id = row.id
            this.editshow = true
        },
        loadOtherData() {
            this.initTree()
        },
        getListData() {
            this.loading = true;
            this.selectData = [];
            this.tableData = []
            getListData(this.list_url, this.search_Obj).then(res => {
                this.loading = false;
                if (res.code === 1) {
                    this.tableData = res.data.resultList;
                    this.total = res.data.totalRecords;
                    this.parents = res.data.parents;
                    this.grade = res.data.grade
                    this.pid = res.data.f_pid
                    this.grout_type = res.data.f_grout_type
                }
            })
        },
        saveOk() {
            this.editshow = false
            this.getListData()
        },
        toChild1(pid){
            this.search_Obj.f_pid = pid
            this.pid = pid
            this.current = 1
            this.search_Obj["pageNum"] = this.current;
            this.getListData()
        },
        clickPrjectDivision(data){
            this.search_Obj.f_pid = data.id
            this.pid = data.id
            this.current = 1
            this.search_Obj["pageNum"] = this.current;
            this.getListData()
        },
        initTree(){
            this.projectDivisionData = []
            getProjectDivisionTreeData(3).then(res=>{
                if(res.code ==1){
                    var treeData = res.data
                    treeData = this.removeEmptyChild(treeData)
                    this.projectDivisionData = treeData
                }
            })
        },
        import(){
            this.importshow = true
        },
        impOk(){
            this.importshow = false
            this.getListData()
        },
        closeImportDialog(){
            this.importshow = false
        },
        handleCommand(grout_type){
            this.search_Obj.f_grout_type = grout_type
            this.doSearch()
        },
        setProjectPlan(){
            this.planshow = true
        },
        closePlanDialog(){
            this.planshow = false
        },
    }
};
</script>